import React from 'react';
import './PC.css';
import Guan from '../../img/pc/Stella Guan.png'
import Casadei from '../../img/pc/Alice Casadei.png'
import Morano from '../../img/pc/Luca Morano.png'
import Coudriet from '../../img/pc/Jason Coudriet.png'
import Moura from '../../img/pc/Tony Moura.png'
import Ramazzotti from '../../img/pc/Federica Ramazzotti.png'
import Wajeeha from '../../img/pc/Rabeea Wajeeha.png'
import Arraes from '../../img/pc/Herman Heitmann Arraes.png'

export default class PC extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      pc: [
        {
          photo: Guan,
          name: 'Stella Guan',
          position: 'Founder & CEO',
          ln: 'https://www.linkedin.com/in/stellaguan/',
        },
        {
          photo: Casadei,
          name: 'Alice Casadei',
          position: 'Freelance Consultant, UX/UI Designer',
          ln: 'https://www.linkedin.com/in/alicecasadei/',
        },
        {
          photo: Morano,
          name: 'Luca Morano',
          position: 'UX Designer',
          ln: 'https://www.linkedin.com/in/lucamorano/',
        },
        {
          photo: Coudriet,
          name: 'Jason Coudriet',
          position: 'Design Leader & Technologist',
          ln: 'http://linkedin.com/in/jcoudriet',
          tw: 'https://twitter.com/jcoudriet',
        },
        {
          photo: Moura,
          name: 'Tony Moura',
          position: 'Founder / CEO',
          ln: 'https://www.linkedin.com/in/tmoura',
        },
        {
          photo: Ramazzotti,
          name: 'Federica Ramazzotti',
          position: 'UX/UI Architect',
          ln: 'https://www.linkedin.com/in/federica-ramazzotti-8a4259126/',
        },
        {
          photo: Wajeeha,
          name: 'Rabeea Wajeeha',
          position: 'Chief Operating Officer',
          ln: 'https://www.linkedin.com/in/rabeeawajeeha/',
        },
        {
          photo: Arraes,
          name: 'Herbert Heitmann Arraes',
          position: 'Design Leadership Manager',
          ln: 'https://www.linkedin.com/in/herbert-heitmann-arraes-0512732',
        },
      ]
    }
  }

  renderPC(item, i) {
    return (
      <div className="pc_item" key={`team-${i}`}>
        <div className="pc_img_block">
          <img className="team_img" src={item.photo} alt={item.name} />
        </div>
        <div className="pc_info">
          <p className="pc_name">{item.name}</p>
          <p className="pc_position">{item.position}</p>
          <div className="pc_links">
            {item.fb && <a className="pc_link social_fb" target='_blank' rel="noreferrer" href={item.fb}></a>}
            {item.ln && <a className="pc_link social_ln" target='_blank' rel="noreferrer" href={item.ln}></a>}
            {item.tw && <a className="pc_link social_tw" target='_blank' rel="noreferrer" href={item.tw}></a>}
          </div>
        </div>
      </div>
    )
  }

  render() {
      return (
          <div className="pc" id='pc'>
              <h3>Program committee</h3>
              <div className='container team_wrap'>
                  <div className="pc_block">
                    {this.state.pc.map((item, i) => this.renderPC(item, i))}
                  </div>
              </div>
          </div>
      )
  }
}